import { ButtonBase, Icon } from "client/Components";
import {
	forwardRef,
	ReactElement,
	Ref
} from "react";
import styles from "./AddRowButton.module.less";

export type AddRowButtonProps = {
	trackingId?: string;
	onClick(): void;
};

export const AddRowButton = forwardRef(
	(props: AddRowButtonProps, ref: Ref<HTMLButtonElement>): ReactElement => {
		const {
			trackingId,
			onClick
		} = props;

		return (
			<ButtonBase
				className={styles.root}
				onClick={onClick}
				ref={ref}
				trackingId={trackingId}
			>
				<Icon value="plus" size="large" />
			</ButtonBase>
		);
	}
);

AddRowButton.displayName = "AddRowButton";